import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// If the logged-in user is an autista, redirect them to /driver
// so that they never see the admin/operator layout.
export default function DriverRedirect({ children }) {
  const { user } = useAuth();
  if (user && user.role === "autista") {
    return <Navigate to="/driver" replace />;
  }
  return children;
}
